import React from "react";
import styles from './index.module.scss';

//导入antd
import { Table, Tooltip } from 'antd';

export const ForensicsModalTable = (props: any) => {
    const { tableDataSource, loading, txId, tableTitle } = props;

    //表格列
    const columns:any = [
        {
            title: '序号',
            dataIndex: 'key',
            key: 'key',
            ellipsis: true,
            align: 'center',
            width: 191,
        },
        {
            title: '文件名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            width:419,
            align: 'center',
            render: (name: any) => (
                <Tooltip placement="topLeft" title={name}>
                    <span>{name}</span>
                </Tooltip>
            )
        },
        {
            title: '哈希值',
            dataIndex: 'Hash',
            key: 'Hash',
            ellipsis: true,
            align: 'center',
            render: (Hash: any) => (
                <Tooltip placement="topLeft" title={Hash}>
                    <span>{Hash}</span>
                </Tooltip>
            )
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 225,
            align: 'center',
        },
    ];

    return (
        <div>
            {
                tableDataSource.length > 0 ? (
                    <div className={styles.forensics_modal_table}>
                        <div className={styles.forensics_modal_table_title}>          
                            <span className={styles.forensics_modal_table_title_span}>{tableTitle}</span>
                            <span className={styles.forensics_modal_table_title_span}>存证编号：{txId}</span>
                        </div>
                        <Table 
                            columns={columns}
                            dataSource={tableDataSource}
                            loading={loading}
                            bordered
                            pagination={{
                                pageSize: 5,
                                hideOnSinglePage: true,
                            }}
                        />
                    </div>
                ): null
            }
        </div>
    )
}